module.exports = __webpack_public_path__ + "static/media/Logo.b2da4f8a.png";